import { ReactNode } from 'react'

import { createPortal } from 'react-dom'

const ID = 'toolbar-sidebar-content'

export const SideBarContainer = () => <div id={ID} />

export const SideBarPortal = ({ children }: { children: ReactNode }) => {
  const portalContainer = document.getElementById(ID)
  return portalContainer ? createPortal(children, portalContainer) : null
}
